<template>
    <div class="w-full hs-accordion" role="presentation">
        <div v-for="(item, index) in items" :key="index" class="hs-accordion-item">
            <h2 :id="`accordion-heading-${index}`">
                <button type="button" class="hs-accordion-trigger"
                    :class="activeIndex === index ? 'hs-accordion-trigger--active' : ''" @click="toggle(index)"
                    :aria-expanded="activeIndex === index" :aria-controls="`accordion-body-${index}`">
                    <span class="hs-accordion-title">{{ item.title }}</span>
                    <svg data-accordion-icon class="w-3 h-3 shrink-0 transition-transform duration-300"
                        :class="activeIndex === index ? 'rotate-180' : ''" xmlns="http://www.w3.org/2000/svg"
                        fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 5 5 1 1 5" />
                    </svg>
                </button>
            </h2>
            <div :id="`accordion-body-${index}`" class="hs-accordion-body"
                :class="activeIndex === index ? 'hs-accordion-body--active' : ''"
                :aria-labelledby="`accordion-heading-${index}`">
                <div class="hs-accordion-content">
                    <div v-html="item.content" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true,
            default: () => [],
        },
        active: null,
    },
    data() {
        return {
            activeIndex: this.active,
        };
    },
    methods: {
        toggle(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        },
    },
};
</script>

<style scoped>
.hs-accordion {
    display: grid;
    gap: 0.75rem;
}

.hs-accordion-item {
    border: 1px solid var(--hs-border);
    border-radius: 16px;
    overflow: hidden;
    background: color-mix(in srgb, var(--hs-surface) 90%, transparent);
    box-shadow: var(--hs-shadow-soft);
}

.hs-accordion-trigger {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.25rem;
    color: var(--hs-muted);
    font-weight: 600;
    background: color-mix(in srgb, var(--hs-surface) 92%, transparent);
    transition: all 0.2s ease;
}

.hs-accordion-trigger:hover {
    color: var(--hs-primary-strong);
    background: color-mix(in srgb, var(--hs-primary) 8%, transparent);
}

.hs-accordion-trigger--active {
    color: var(--hs-primary-strong);
    background: color-mix(in srgb, var(--hs-primary) 13%, transparent);
}

.hs-accordion-title {
    text-align: left;
}

.hs-accordion-body {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.28s ease;
}

.hs-accordion-body--active {
    max-height: 1000px;
}

.hs-accordion-content {
    padding: 1rem 1.25rem 1.25rem;
    color: var(--hs-muted);
    border-top: 1px solid color-mix(in srgb, var(--hs-border) 80%, transparent);
}
</style>
